import { render } from "./form-password.vue?vue&type=template&id=438d28ab"
import script from "./form-password.vue?vue&type=script&lang=js"
export * from "./form-password.vue?vue&type=script&lang=js"

import "./form-password.vue?vue&type=style&index=0&id=438d28ab&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__